export var ParentType;
(function (ParentType) {
    ParentType["Mother"] = "Mother";
    ParentType["Father"] = "Father";
    ParentType["Stepfather"] = "Stepfather";
    ParentType["Stepmother"] = "Stepmother";
    ParentType["FosterParent"] = "FosterParent";
    ParentType["Parent1"] = "Parent1";
    ParentType["Parent2"] = "Parent2";
    ParentType["Other"] = "Other";
})(ParentType || (ParentType = {}));
export class ParentTypeHelper {
    static getName(type) {
        switch (type) {
            case ParentType.Mother:
                return 'Mama';
            case ParentType.Father:
                return 'Papa';
            case ParentType.Stepmother:
                return 'Plusmama';
            case ParentType.Stepfather:
                return 'Pluspapa';
            case ParentType.Parent1:
                return 'Ouder 1';
            case ParentType.Parent2:
                return 'Ouder 2';
            case ParentType.Other:
                return 'Voogd';
            case ParentType.FosterParent:
                return 'Pleegouder';
        }
    }
    static getPublicTypes() {
        return [ParentType.Mother, ParentType.Father, ParentType.Stepmother, ParentType.Stepfather, ParentType.FosterParent, ParentType.Other];
    }
}
//# sourceMappingURL=ParentType.js.map